import React from 'react';
import PropTypes from 'prop-types';
import { uniqBy } from 'ramda';
import buildNextUrl from 'utils/buildNextUrl';
import { FormattedMessage } from 'react-intl';
import { Row, Column, Page } from 'components/shared/Layout';
import { getCta } from '../ErrorActions';
import { StyledP, ContextItem, S3ErrorContext } from '../ErrorSection.styles';

const ApolloErrorSection = ({ error, parent, location }) => {
  const nextUrl = buildNextUrl(location);

  return (
    <Page data-testid="apollo-error-section">
      <Row>
        <Column span={8} start={5} justifyContent="center">
          <h1>
            <FormattedMessage id="errorBoundary.somethingWrong" />
          </h1>
        </Column>

        {error.graphQLErrors && (
          <>
            {uniqBy((e) => e.extensions.code, error.graphQLErrors).map(
              ({ message, extensions: { code, S3_CORRELATION_ID: s3CID, CORRELATION_ID: voyagerCID, context } }) => {
                const hasContext = Boolean(context);

                return (
                  <Column key={code}>
                    <Column span={10} start={4}>
                      <StyledP>
                        <FormattedMessage id="errorBoundary.errorCode" /> {code}
                      </StyledP>
                    </Column>

                    <Column span={10} start={4}>
                      <StyledP>
                        <FormattedMessage id="errorBoundary.errorMessage" /> {message}
                      </StyledP>
                    </Column>

                    {voyagerCID && (
                      <Column span={10} start={4}>
                        <StyledP>
                          <FormattedMessage id="errorBoundary.voyagerCorrelation" /> {voyagerCID}
                        </StyledP>
                      </Column>
                    )}

                    {s3CID && (
                      <Column span={10} start={4}>
                        <StyledP>
                          <FormattedMessage id="errorBoundary.s3Correlation" /> {s3CID}
                        </StyledP>
                      </Column>
                    )}

                    {hasContext && (
                      <Column span={10} start={4}>
                        <S3ErrorContext>
                          {Object.keys(context).map((c) => (
                            <li key={c}>
                              <ContextItem>{c}: </ContextItem>
                              {context[c]}
                            </li>
                          ))}
                        </S3ErrorContext>
                      </Column>
                    )}
                  </Column>
                );
              }
            )}
          </>
        )}

        {getCta(error, parent, nextUrl)}
      </Row>
    </Page>
  );
};

ApolloErrorSection.propTypes = {
  parent: PropTypes.instanceOf(React.Component),
  error: PropTypes.shape({
    actionCode: PropTypes.string,
    graphQLErrors: PropTypes.arrayOf(
      PropTypes.shape({
        message: PropTypes.string.isRequired,
        extensions: PropTypes.shape({
          code: PropTypes.string.isRequired
        }).isRequired
      })
    ).isRequired
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string
  })
};

export default ApolloErrorSection;
